<script lang="ts">
  import { Badge, Progress } from "sveltestrap";
  import Journalist, { MAX_SKILL_LEVEL } from "../model/journalist";

  export let journalist: Journalist = undefined;
  export let skills: {[key: string] : number} = undefined;
  export let filter: string[] = undefined;

  let sorted: [string, number][];
  $: sorted = Object.entries(skills || journalist?.skills || {})
      .filter(item => !filter || filter.includes(item[0]))
      .sort((a, b) => b[1] - a[1]);
</script>

{#if sorted.length !== 0}
  <table class="w-100">
    {#each sorted as [skill, _value]}
      <tr>
        <th>
          <Badge color="secondary" class="w-100">{skill}</Badge>
        </th>
        <td class="w-100">
          <Progress animated={false} class="ms-2" style="height: 1.25rem" striped color="secondary" max={MAX_SKILL_LEVEL * 1000} value={journalist.getAdjustedSkillLevel(skill) * 1000} />
        </td>
      </tr>
    {/each}
  </table>
{/if}